import json from './json';
import proto from './proto';

const api = {
  ...json,
  ...proto,
};

export default api;
